import React from 'react'

import styleClasses from './classes.module.css'

export function Divider() {
  return <div className={styleClasses.divider} />
}
